<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-command-line`]" width="1em" height="1em" v-bind="$attrs"><path d="M13.626 16.96l-1.254 1.164a1 1 0 00-.053 1.413l.005.006.013.013 4.45 4.528-4.45 4.528a1 1 0 00.016 1.414l.019.018 1.254 1.164a1 1 0 001.39-.028l6.356-6.391a1 1 0 000-1.41l-6.356-6.391a1 1 0 00-1.39-.028zM25 27a1 1 0 00-1 1v2a1 1 0 001 1h9a1 1 0 001-1v-2a1 1 0 00-1-1h-9z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M44 4a2 2 0 012 2v36a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h40zm-2 4H6v32h36V8z"/></svg>
</template>
<script>

export default {
  name: 'IconCommandLine',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
